import request from '@/blocks/request';
export function getCarPrizeList(params) {
  return request({
    url: `/open/api/relate_serial_group_by_hot`,
    params,
  });
}
export function saveClueInfo(data) {
  return request({ 
    url: `/activities/${process.env.VUE_APP_H5_KEY}/inquiry/save`,
    method: 'POST',
    data,
  });
}